import { combineReducers } from "redux";

import { usersReducer } from './usersReducer';
import { showcaseReducer } from "./showcaseReducer";

import { LOGOUT_USER } from 'constants/actionTypes';

const appReducer = combineReducers({
  users: usersReducer,
  showcase: showcaseReducer
})

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_USER) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer;